<template>
  <!-- dialog add people -->
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'900px'"
    :modalAppendToBody="modalAppendToBody"
    :appendToBody="true"
    :classDialog="'add-people-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <h3 class="dialogTitle">Thêm người phối hợp</h3>
      <el-row :gutter="12" class="margin-bottom-10">
        <el-col :span="7">
          <el-checkbox
            size="mini"
            :border="true"
            v-model="checkAll"
            @change="checkAllChange"
            >Chọn tất cả
          </el-checkbox>
        </el-col>
        <el-col :span="17" class="flex-row flex__left">
          <el-input
            v-model="keyword"
            size="mini"
            placeholder="Gõ tên để bắt đầu tìm kiếm"
            class="style-fullWidth input-border__bottom input-border__radius__0"
            @keydown.enter.exact.native="search"
          ></el-input
          >&nbsp;&nbsp;
        </el-col>
      </el-row>
      <el-checkbox-group v-model="selectedUserDeptRoleIds">
        <el-table
          ref="multipleTable"
          :data="userDeptRoleViews"
          style="width: 100%"
          size="mini"
          :show-header="false"
          max-height="300"
        >
          <el-table-column width="50">
            <template slot-scope="scope">
              <el-checkbox
                :label="scope.row.id"
                class="checkbox-add-people"
                size="medium"
              ></el-checkbox>
            </template>
          </el-table-column>
          <!--          <el-table-column width="50">-->
          <!--            <template slot-scope="scope">-->
          <!--              <div-->
          <!--                class="avatar_fake flex-row flex__center margin-right-10"-->
          <!--                @click="itemClicked(scope.row)"-->
          <!--              >-->
          <!--                {{ scope.row.fullName | buildShortNameFilter }}-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column show-overflow-tooltip>
            <template slot-scope="scope" class="">
              <span class="userShortInfo" @click="itemClicked(scope.row)">
                <div class="name">{{ scope.row.fullName }}</div>
                <div class="role">
                  {{ scope.row.positionName || scope.row.roleName }} -
                  {{ scope.row.deptName }}
                </div>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="submit">
          <i class="fas fa-check-circle"></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="cancel">
          <i class="fas fa-ban"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import buildShortNameFilter from "../../../filters/buildShortNameFilter";
import h from "../../../services/h";
import utils from "../../../services/utils";

export default {
  name: "dialog-add-people",
  props: [
    "isOpen",
    "addedPeopleIds",
    "taskId",
    "modalAppendToBody",
    "delegatorId",
  ],
  filters: { buildShortNameFilter },
  components: {
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    VuePerfectScrollbar,
  },
  data() {
    return {
      keyword: null,
      selectedUserDeptRoleIds: [],
      userDeptRoleViews: [],
      allUserDeptRoleViews: [],
      checkAll: false,

      settings: {
        maxScrollbarLength: 350,
      },
    };
  },

  computed: {
    deptId() {
      return this.$store.getters.userDeptRole
        ? this.$store.getters.userDeptRole.deptId
        : null;
    },
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
  },

  watch: {
    selectedUserDeptRoleIds(newValue) {
      this.checkAll =
        newValue &&
        newValue.length &&
        newValue.length === this.userDeptRoleViews.length;
    },
  },

  created() {
    this.loadAssigners().then(() => {
      this.filterAddedPeople();
      this.userDeptRoleViews = this.allUserDeptRoleViews;
    });
  },

  methods: {
    filterAddedPeople() {
      this.allUserDeptRoleViews = h.findAll(
        this.allUserDeptRoleViews,
        (userDeptRoleView) =>
          this.addedPeopleIds.indexOf(userDeptRoleView.id) === -1
      );
    },

    loadAssigners() {
      return userDeptRoleViewService.findAll().then((response) => {
        this.allUserDeptRoleViews = response.data.sort((item1, item2) =>
          utils.compareUserDeptRoleView(item1, item2)
        );
      });
      // return userDeptRoleViewService
      //   .findAllCoordinatorForTask(this.taskId, {
      //     sort: ["deptName", "positionOrder", "fullName"]
      //   }, this.delegatorId)
      //   .then(response => {
      //     this.allUserDeptRoleViews = response.data;
      //   });
    },

    itemClicked(item) {
      let index = this.selectedUserDeptRoleIds.indexOf(item.id);
      index === -1
        ? this.selectedUserDeptRoleIds.push(item.id)
        : this.selectedUserDeptRoleIds.splice(index, 1);
    },

    checkAllChange() {
      this.selectedUserDeptRoleIds = this.checkAll
        ? h.collect(this.userDeptRoleViews, (item) => item.id)
        : [];
    },

    validate() {
      if (
        !this.selectedUserDeptRoleIds ||
        !this.selectedUserDeptRoleIds.length
      ) {
        this.$message({
          message: "Vui lòng chọn Người phối hợp",
          type: "error",
        });
        return false;
      }

      return true;
    },

    submit() {
      if (!this.validate()) return;
      let selectedUserDeptRoleViews = h.findAll(
        this.userDeptRoleViews,
        (item) =>
          this.selectedUserDeptRoleIds &&
          this.selectedUserDeptRoleIds.indexOf(item.id) !== -1
      );
      this.$emit("submit", { userDeptRoleViews: selectedUserDeptRoleViews });
    },

    cancel() {
      this.$emit("closeDialog");
    },

    search() {
      this.checkAll = false;
      this.selectedUserDeptRoleIds = [];
      this.userDeptRoleViews = this.keyword
        ? h.findAll(this.allUserDeptRoleViews, (userDeptRoleView) =>
            utils.isUserDeptRoleMatchWithQuery(userDeptRoleView, this.keyword)
          )
        : this.allUserDeptRoleViews;
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/job/create-job/dialog-add-people.vue